import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import PropTypes from 'prop-types'

import { removeItemFromLocalStorage } from '../../helpers/helpers'
import SearchField from '../fields/SearchField'
import { Pagination } from '../ui/Pagination'
import DocumentCard from './DocumentCard'

const textByStatus = { loading: 'Cargando...', empty: 'No se encontraron resultados.' }

const Documents = ({ documents }) => {
  const navigate = useNavigate()

  useEffect(() => {
    removeItemFromLocalStorage(['breadcrumbItem'])
  }, [])

  const key = documents.status === 'loading' ? documents.status : documents.total_count === 0 ? 'empty' : 'success'

  return (
    <>
      <SearchField
        name="search"
        placeholder="Buscar por nombre del documento"
        containerClassName="md:w-80"
        className="pb-10"
      />
      {key !== 'success' ? (
        <p className="font-bold text-center">{textByStatus[key]}</p>
      ) : (
        <>
          <div className="md:grid grid-cols-2 gap-5">
            {documents.data?.map((document, index) => (
              <DocumentCard
                key={index}
                documentData={document}
                handleSelectedCard={() => navigate(`/documentos/${document.id}`)}
                parentClassName="mt-5 md:mt-0"
              />
            ))}
          </div>
          <Pagination numPages={documents.total_pages} />
        </>
      )}
    </>
  )
}

Documents.propTypes = {
  documents: PropTypes.object
}

export default Documents
